import { render, staticRenderFns } from "./CProfileDetailForPublic.vue?vue&type=template&id=72967303&"
import script from "./CProfileDetailForPublic.vue?vue&type=script&lang=ts&"
export * from "./CProfileDetailForPublic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports